export default __webpack_public_path__ + "static/database-8d1b516a56865f37d5ee3abf9fa6bf92.jpeg";